export const LANGUAGE_META = {
  en: { label: 'English', flag: '🇺🇸' },
  fr: { label: 'Français', flag: '🇫🇷' },
  es: { label: 'Español', flag: '🇪🇸' },
  de: { label: 'Deutsch', flag: '🇩🇪' },
  it: { label: 'Italiano', flag: '🇮🇹' },
  pt: { label: 'Português', flag: '🇵🇹' },
  ja: { label: '日本語', flag: '🇯🇵' },
  zh: { label: '中文', flag: '🇨🇳' },
  ar: { label: 'العربية', flag: '🇸🇦' },
  ru: { label: 'Русский', flag: '🇷🇺' }
} as const;

export type LanguageCode = keyof typeof LANGUAGE_META;

export const SUPPORTED_LANGUAGES: LanguageCode[] = Object.keys(LANGUAGE_META) as LanguageCode[];
